<template >
    <div class="min-w-s mb-1 text-base font-medium text-racing-stars-yellow">Step 5 of 14</div>
    <div class="  bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700 ">
        <div class="bg-gradient-to-r from-racing-stars-yellow to-yellow-200 h-2.5 rounded-full"
            :style="{ 'width': 7.142857143 * 5 + '%' }"></div>
    </div>
    <p v-if="meeting.jackpot.price > 0" class="text-center text-base  max-w-sm">The
        entry fee for this race is <b class="text-racing-stars-yellow">'{{
                meeting.jackpot.price
        }}'</b> in-game Stars to enter. These will be taken from your in-game balance when you complete your race.</p>

    <p v-else class="text-center text-base max-w-sm">This race is <b class="text-racing-stars-yellow">'Free To Play'</b>. You wont need any Stars in your account to enter!</p>

    <Disclosure v-slot="{ open }">
        <DisclosureButton
            class="  mt-1 flex w-full justify-between rounded-md bg-gray-500 px-4 py-2 text-left text-sm font-medium text-gray-200 hover:text-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
            <span>Learn more about entry fees?</span>
            <ChevronUpIcon :class="open ? 'rotate-180 text-gray-200' : ''" class="h-5 w-5 text-gray-200" />
        </DisclosureButton>

        <transition enter-active-class="transition ease duration-500 transform"
            enter-from-class="opacity-0 -translate-y-4" enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease duration-300 transform" leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-4ray">
            <DisclosurePanel class="px-0 pt-0 pb-0 text-sm text-gray-200  max-w-sm">

                <ul class="list-none p-2 pb-0 text-sm  ">
                    <li class="pb-2  ">
                        <b class="text-racing-stars-yellow">'Free To Play'</b> : This form of race
                        is free to enter, often winning you Stars.
                    </li>
                    <li class="pb-0  ">
                        <b class="text-racing-stars-yellow">'Stars'</b> : This form of race costs
                        in-game Stars to enter, often winning cash prizes.
                    </li>
                </ul>
                <!-- <p v-if="meeting.jackpot.price > 0 ">This race costs <b class="text-racing-stars-yellow"> <DatabaseIcon class="w-4 mr-1" /> {{ meeting.jackpot.price }} in-game tokens to enter.</b></p>
                                                                                                                         -->

            </DisclosurePanel>
        </transition>
    </Disclosure>

    <button type="button" :v-model="tutorialStep" @click.stop="$emit('updateTutorialStep', (tutorialStep += 1));"
        class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
        Next step
    </button>
</template>

<script>
import Popper from 'vue3-popper'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon, ChevronDownIcon} from '@heroicons/vue/outline'

export default {
    props: {
        meeting: {
            type: Object,
            default: {}
        },
        tutorialStep: {
            type : Number,
        },
    },
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popper,
        ChevronDownIcon,
        ChevronUpIcon,
    },
}

</script>